interface ImgAppProps {
    className?: string;
    showFloatingBoxes?: boolean;
}

const FloatingBox: React.FC<{ title: string, bgColor?: string}> = ({ title, bgColor = 'bg-[#5bb960]' }) => {
    return (
        <div className={`${bgColor} backdrop-blur-sm rounded-[12px] p-4`}>
            <li className='leading-[1.2] text-left font-poppins text-white font-light text-[20.2px]'>{title}</li>
        </div>
    );
};

export const ImgApp: React.FC<ImgAppProps> = ({ className = '', showFloatingBoxes = false }) => {
    const defaultClasses = 'object-contain max-w-full h-auto';
    const combinedClasses = className ? `${defaultClasses} ${className}` : defaultClasses;
    
    if (showFloatingBoxes) {
        return (
            <div className='flex flex-col md:relative md:inline-block w-full max-w-[300px] md:max-w-[400px]'>
                <img 
                    className={combinedClasses} 
                    src='https://teraquiz.s3.us-east-005.backblazeb2.com/teraquiz/image_1754495004868305848_6893781c.png'
                    alt="App preview"
                />
                
                {/* Caixas embaixo no mobile, sobrepostas no desktop */}
                <div className='flex flex-col gap-3 mt-4 md:mt-0 md:absolute md:bottom-[-16px] md:transform md:translate-x-52 z-20'>
                    <FloatingBox
                        title="Interface intuitiva"
                    />
                    
                    <FloatingBox
                        title="Critérios organizados por área"
                    />
                    
                    <FloatingBox
                        title="Cálculo automático e interpretação imediata"
                    />
                    
                    <FloatingBox
                        title="E muito mais!"
                        bgColor="bg-[#9864da]"
                    />
                    <img className="border border-4 border-[#9864da] rounded-[8px]" src="https://teraquiz.s3.us-east-005.backblazeb2.com/teraquiz/image_1754508844643769887_6893ae2c.webp"></img>
                </div>
            </div>
        );
    }
    
    return (
        <img 
            className={combinedClasses} 
            src='https://teraquiz.s3.us-east-005.backblazeb2.com/teraquiz/image_1754495004868305848_6893781c.png'
            alt="App preview"
        />
    );
};